import classNames from 'classnames'
import React from 'react'

export default function NextButton(props) {
	const reverse = props && props.reverse;
	const disabled = props && props.disabled
	return (
		<svg
			viewBox="0 0 473.654 473.654"
			style={{
				enableBackground: "new 0 0 473.654 473.654"
		 	}}
			className={classNames("tour-button", {'prev': reverse, disabled})}
		>
			<circle cx="236.827" cy="236.827" r="236.827"/>
			<path style={{fill:'#FFFFFF'}} d="M424.285,216.091c-27.011-27.011-54.018-54.022-81.029-81.033
			c-17.124-17.127-47.781-4.529-47.781,19.737c0,13.051,0,26.098,0,39.15c-70.951,0-141.898,0-212.845,0
			c-54.332,0-54.815,84.159-0.606,84.159c71.153,0,142.302,0,213.455,0c0,11.937,0,23.873,0,35.81
			c-0.146,1.731-0.105,3.455,0.108,5.153c0.8,12.038,8.04,19.764,17.09,23.141c8.867,4.353,19.711,4.241,29.008-3.803
			c1.511-1.148,2.891-2.464,4.121-3.953c26.233-26.229,52.466-52.462,78.696-78.692C435.342,244.916,435.047,226.85,424.285,216.091z"
			/>
		</svg>
	);  
}
